module.exports = __webpack_public_path__ + "static/media/catalog.3dbff942.svg";